// Small display helpers for the Ad Builder / list.

export const isEmpty = (v) =>
  v === null || v === undefined || v === "" || (typeof v === "string" && v.trim() === "");

export const val = (v, fallback = "—") => (isEmpty(v) ? fallback : v);

// Horse heights are HANDS.INCHES (1 hand = 4 in): only .0-.3 are valid, so 14.4 is written 15.0.
export const HEIGHTS = Array.from({ length: 10 }, (_, i) => i + 10).flatMap((h) => [0, 1, 2, 3].map((d) => `${h}.${d}`));
export const normalizeHeight = (v) => {
  const m = String(v ?? "").trim().match(/^(\d{1,2})(?:\s*[.,']\s*(\d))?\s*(?:hh|h|hands)?$/i);
  return m && +m[1] >= 10 && +m[1] <= 19 && +(m[2] ?? 0) <= 3 ? `${+m[1]}.${m[2] ?? 0}` : null;
};
export const fmtHeight = (v) => (isEmpty(v) ? null : `${normalizeHeight(v) || v} HH`);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Smartsheet date-only values ("2026-09-20") must render date-only, never
// parsed as UTC and shifted into the browser timezone.
export const fmtDate = (v) => {
  if (isEmpty(v)) return null;
  if (typeof v === "string") {
    const m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const [, y, mo, d] = m;
      return `${MONTHS[parseInt(mo, 10) - 1]} ${parseInt(d, 10)}, ${y}`;
    }
  }
  const d = new Date(v);
  if (isNaN(d.getTime())) return v;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

// Lifecycle bucket derived from dates (used for the date filter).
export const dateBucket = (hi) => {
  const today = new Date();
  const preview = hi?.preview_start_date ? new Date(hi.preview_start_date) : null;
  const close = hi?.sale_close_date ? new Date(hi.sale_close_date) : null;
  if (close && !isNaN(close) && close < today) return "closed";
  if (preview && !isNaN(preview) && preview > today) return "upcoming";
  return "active";
};

export const statusTone = (status = "") => {
  const s = status.toLowerCase();
  if (s.includes("complete") || s.includes("sold")) return "bg-stone-800 text-stone-50 border-stone-900";
  if (s.includes("active") || s.includes("open") || s.includes("live"))
    return "bg-emerald-100 text-emerald-900 border-emerald-300";
  if (s.includes("preview") || s.includes("upcoming"))
    return "bg-blue-100 text-blue-900 border-blue-300";
  if (s.includes("draft") || s.includes("pending"))
    return "bg-orange-50 text-orange-800 border-orange-200";
  return "bg-stone-100 text-stone-700 border-stone-300";
};
